import React, { useContext, useEffect, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getMelComponent,
  saveMelComponent,
  deleteMelComponent,
  getStationCodeList,
} from 'api/pgads.js'

import { ErrorContext } from 'context'
import CommonScreen from './CommonScreen'
import { Button, Select, Input } from 'antd'
import styled from 'styled-components'

import { getStations } from '../../core'
import R from 'ramda'
const TableTD = styled.td`
  text-align: end;
`

const headers = [
  strCol({
    ident: 'stations',
    display: 'Stations',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'melSystemCode',
    display: 'Mel System Code',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'melSubSystemCode',
    display: 'Mel Sub System Code',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'component',
    display: 'Component',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'comments',
    display: 'Comments',
    isKey: false,
    ellipsis: true,
    width: 400,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Mel Component'

const MelComponenet = ({ targetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)

  const [scodeList, setCodeList] = useState([])
  const [scodeMap, setCodeMap] = useState([])

  useEffect(
    _ => {
      getStationCodeList(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.compose(R.toLower, R.prop('stationName')))(data)
        setCodeList(sd)
        const md = R.compose(
          R.fromPairs,
          R.map(d => [d.stationCode, d.stationName])
        )(data)
        setCodeMap(md)
      })
    },
    [setError, targetInfo]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Station :</TableTD>
            <td>
              <Select
                style={{ width: '100%' }}
                value={insertData.stations}
                onChange={value =>
                  setInsertData({ ...insertData, stations: value })
                }
              >
                {scodeList.map(s => (
                  <Select.Option key={s.stationCode} value={s.stationCode}>
                    {s.stationCode}-{s.stationName}
                  </Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Mel System Code :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.melSystemCode}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    melSystemCode: e.target.value,
                  })
                }}
              />
            </td>
            <TableTD>Mel Sub System Code :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.melSubSystemCode}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    melSubSystemCode: e.target.value,
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <TableTD>Component :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.component}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    component: e.target.value,
                  })
                }}
              />
            </td>
            <TableTD>Comments :</TableTD>
            <td colSpan={3}>
              <Input
                style={{ width: '100%' }}
                value={insertData.comments}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    comments: e.target.value,
                  })
                }}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'stations'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => scodeMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            scodeList[rowData.stations] || rowData.stations,
        }
      : header
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={saveMelComponent}
      retrieveTask={getMelComponent}
      deleteTask={deleteMelComponent}
      altBy={d => d.stations}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && insertComp}
      insertCompHeight={130}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  stationList: getStations(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(MelComponenet)
